import createConverter from './lib/create_converter';
import Account from 'models/account';

export default createConverter(Account);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/account_converter.js